import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { useMatch } from 'react-router-dom';


const Header = () => {
  const navigate = useNavigate()
  const [navContent, setNavContent] = useState("");
  

  const matchStudentStore = useMatch("/store/student");
  const matchProductDetails = useMatch("/product-details/:id");
  const matchShoppingCart = useMatch("/shopping-cart");
  const matchSavedProduct = useMatch("/saved-product");

  useEffect(() => {
    if (matchStudentStore) {
      setNavContent("Store");
    } else if (matchProductDetails) {
      setNavContent("Store/Product Details");
    } else if (matchShoppingCart) {
      setNavContent("Store/Shopping Cart");
    } else if (matchSavedProduct) {
      setNavContent("Store/Saved Product");
    }  else {
      setNavContent("");
    }
  }, [matchStudentStore, matchProductDetails, matchShoppingCart]);

  // const totalQuantity = useSelector(state => state.cart.totalQuantity);
  // console.log(totalQuantity)

  const itemInCart = useSelector(state => state.cart.items); 
  const productCount = itemInCart.length

  const savingProducts = useSelector((state) => state?.product?.productSavedByUser?.saved || [])
  const [productDelete, setProductDelete] = useState(savingProducts)
  console.log(productDelete)
  const savingCount = productDelete.length
  console.log(savingCount)
  
  return (      
    <div className='flex justify-between w-full px-[50px] py-[17px] border-b border-b-#FFF-500'>
      <div className='flex gap-[10px]'>
      <h2 className='text-[#BBB] font-manrope text-[16px] leading-[24px]'>ERC/Store</h2>
      <p className='text-[#00296B]'>{navContent}</p>
      </div>
    <div className='flex justify-end gap-[20px]'>
    <div className='relative flex flex-col cursor-pointer' onClick={() => { window.scrollTo(0,0); navigate("/shopping-cart")}}>
  <img
    src="https://res.cloudinary.com/dmrtylvtc/image/upload/v1721855731/ERC/svg_5_ubndfk.svg"
    alt="Icon"
    className="w-full h-auto"
  />
<span className="absolute top-0 left-[15px] bg-[#00296B] p-[2px] rounded-[30px] text-[#fff] transform -translate-y-1/2">
    {productCount}
  </span>
</div>
{/* <div className='cursor-pointer' onClick={() => { window.scrollTo(0,0); navigate("/saved-product")}}>
<img src='https://res.cloudinary.com/dmrtylvtc/image/upload/v1721855731/ERC/svg_4_b6psf9.svg'/>

</div> */}

<div className='relative flex flex-col cursor-pointer' onClick={() => { window.scrollTo(0,0); navigate("/saved-product")}}>
  <img
    src="https://res.cloudinary.com/dmrtylvtc/image/upload/v1721855731/ERC/svg_4_b6psf9.svg"
    alt="Icon"
    className="w-full h-auto"
  />
<span className="absolute top-0 left-[15px]  p-[2px] rounded-[30px] text-[#fff] transform -translate-y-1/2">
    {/* {savingCount} bg-[#00296B]*/}
  </span>
</div>

    {/* <img src='https://res.cloudinary.com/dmrtylvtc/image/upload/v1721855731/ERC/svg_3_knlb4n.svg'/> */}
    </div>
    </div>
  )
}

export default Header
